import getOwnerDocument from './getOwnerDocument';
/**
 * Returns the window for the specified node.
 */

export default function getOwnerWindow(node) {
  var document = getOwnerDocument(node);
  return document.defaultView;
}
//# sourceMappingURL=getOwnerWindow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/getOwnerWindow.js
// module id = 109
// module chunks = 0 1